import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import Slick from '@organisms/Slick';
import { Button } from '@components/ButtonV2';
import {
  NewTaxonomyItemFieldsFragment,
  TaxonomyTermFragment,
} from '@gql/generated';
import Icon from '@components/Icon';

const ClearButton = styled(Button)`
  flex-shrink: 0;
  color: rgba(18, 158, 220);
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  margin-right: 20px;
`;

const Tag = styled.div<{ isSelected: boolean }>`
  display: inline-flex;
  align-items: center;
  color: ${({ isSelected }) => (isSelected ? '#fff' : 'rgb(21,21,21)')};
  font-size: 14px;
  line-height: 17px;
  font-weight: 300;
  border-radius: 4px;
  padding: 5px;
  padding: 9px 8px;
  background-color: #6c96a7;
  outline: none;

  i {
    margin-left: 5px;
  }
`;

type Props = {
  selectedTerms: Record<string, string[]>;
  taxonomies: NewTaxonomyItemFieldsFragment[];
  handleSelectTerm(term: TaxonomyTermFragment, slug: string);
  clearAll(): void;
};
export const SelectedTermsComponent = (props: Props) => {
  const { selectedTerms, taxonomies, handleSelectTerm, clearAll } = props;

  const selectedElements = [];
  (taxonomies || []).forEach((taxonomy) => {
    if (selectedTerms?.[taxonomy.slug]) {
      const selectedTaxonomies = [];

      const terms =
        taxonomy?.subcategories?.length > 0
          ? taxonomy.subcategories.flatMap((sub) => sub.terms)
          : taxonomy.nonSubcategorized;

      selectedTaxonomies.push(
        ...selectedTerms[taxonomy.slug]
          .map((slug) =>
            terms.find((term) => (term.slug === slug ? term : null))
          )
          .filter((item) => !!item)
      );

      if (selectedTaxonomies?.length > 0) {
        selectedElements.push(
          ...selectedTaxonomies.map((term) => (
            <Tag
              key={term.slug}
              isSelected={true}
              data-term={term?.slug}
              data-taxonomy={taxonomy.slug}
            >
              {term.name}
              <button
                className="text-inherit"
                onClick={(e) => {
                  handleSelectTerm(term, taxonomy.slug);
                }}
              >
                <Icon name="ygb-icon-close" />
              </button>
            </Tag>
          ))
        );
      }
    }
  });

  if (selectedElements.length > 0) {
    return (
      <div className="flex flex-wrap gap-2 items-center mt-5 mb-2.5 pr-2">
        <ClearButton onClick={clearAll} link>
          <Trans id="metadata.clear_all" message={'Clear all'} />
        </ClearButton>
        {selectedElements}
      </div>
    );
  }

  return null;
};
